import React from 'react';
import { Typography, Checkbox } from '@mui/material';
import { CheckBoxArea, SquareRadio, SquareRadioChecked, StyledCheckIcon } from './styles';

const MobileFilterCheckbox = ({ label, selected, onToggle }) => (
  <CheckBoxArea>
    <Typography style={{ flexGrow: 1 }}>{label}</Typography>
    <Checkbox
      checked={selected}
      onClick={onToggle}
      icon={<SquareRadio />}
      checkedIcon={(
        <SquareRadioChecked>
          <StyledCheckIcon />
        </SquareRadioChecked>
        )}
    />
  </CheckBoxArea>
);

export default MobileFilterCheckbox;
